"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _Breadcrumb = require("./Breadcrumb.proptypes");

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "Breadcrumb__MainWrapper",
  componentId: "sc-1ydwfj5-0"
})(["display:flex;flex-direction:column;border-radius:", ";font-family:", ";*:focus{outline:none;}"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.micro);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.default;
});

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "Breadcrumb__ContentWrapper",
  componentId: "sc-1ydwfj5-1"
})(["display:flex;justify-content:space-between;flex-direction:row;", ""], function (props) {
  return props.hasBorderBottom && "border-bottom: 1px solid  ".concat(props.theme.colors[props.border] || props.theme.colors.greyLight, ";");
});

var selectedCrumbStyle = (0, _styledComponents.css)(["&::before{}"]);

var BreadCrumbUl = _styledComponents.default.ul.withConfig({
  displayName: "Breadcrumb__BreadCrumbUl",
  componentId: "sc-1ydwfj5-2"
})(["display:flex;aligh-items:center;font-size:", ";margin:0;padding:0;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize.XSmall;
});

var BreadCrumbLi = _styledComponents.default.li.withConfig({
  displayName: "Breadcrumb__BreadCrumbLi",
  componentId: "sc-1ydwfj5-3"
})(["display:flex;align-items:center;list-style:none;svg{margin:0 ", ";}&:focus{border:1px solid ", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.tiny;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.black;
});

var CrumbName = _styledComponents.default.li.withConfig({
  displayName: "Breadcrumb__CrumbName",
  componentId: "sc-1ydwfj5-4"
})(["display:inline;color:", ";cursor:pointer;border-bottom:none;", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.default;
}, function (_ref7) {
  var selected = _ref7.selected;
  return selected && selectedCrumbStyle;
});

CrumbName.displayName = 'CrumbName';

var Breadcrumb = function Breadcrumb(props) {
  var theme = props.theme,
      _props$crumbs = props.crumbs,
      crumbs = _props$crumbs === void 0 ? [] : _props$crumbs,
      accessible = props.accessible,
      customProperties = props.customProperties,
      disabledColor = props.disabledColor,
      activeColor = props.activeColor,
      hoverColor = props.hoverColor,
      hoverUnderlined = props.hoverUnderlined,
      isClickable = props.isClickable,
      activeStep = props.activeStep,
      hasBorderBottom = props.hasBorderBottom,
      fontSize = props.fontSize,
      target = props.target;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return crumbs.length > 0 ? /*#__PURE__*/_react.default.createElement(MainWrapper, customProperties, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
      hasBorderBottom: hasBorderBottom
    }, /*#__PURE__*/_react.default.createElement(BreadCrumbUl, null, crumbs.map(function (crumb, index) {
      return /*#__PURE__*/_react.default.createElement(BreadCrumbLi, {
        className: "bread-crumb-item",
        key: Math.random(),
        tabIndex: tabIndex
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: isClickable ? crumb.path : null,
        size: fontSize,
        color: crumb.step === activeStep ? activeColor : disabledColor,
        theme: theme,
        hoverUnderlined: hoverUnderlined,
        hoverColor: hoverColor,
        target: target,
        accessible: false
      }, crumb.title, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: index !== crumbs.length - 1 ? _constant.BREADCRUMB_TYPE_ICONS.CHEVRON_RIGHT : _constant.BREADCRUMB_TYPE_ICONS,
        color: _constant.ICON_COLOR,
        fontsize: _constant.ICON_SIZE,
        accessible: false
      })));
    })))) : null;
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Breadcrumb.propTypes = _Breadcrumb.BreadcrumbPropTypes.PropTypes;
Breadcrumb.defaultProps = _Breadcrumb.BreadcrumbPropTypes.DefaultProps;
var _default = Breadcrumb;
exports.default = _default;